export default "__VITE_ASSET__d11254e9__"